/**
 * Environment configuration
 */

const isProduction =
  import.meta.env.MODE === 'production' ||
  import.meta.env.VITE_APP_ENV === 'production';

const enableMocks =
  import.meta.env.VITE_ENABLE_MOCKS === 'true';

/**
 * Security check:
 * Mocks must never be enabled in production.
 */
if (isProduction && enableMocks) {
  const errorMsg =
    'SECURITY FATAL: VITE_ENABLE_MOCKS cannot be enabled in a production build environment.';

  console.error(errorMsg);

  if (typeof window !== 'undefined') {
    document.body.innerHTML = `
      <div
        style="
          padding: 40px;
          color: red;
          font-family: sans-serif;
          text-align: center;
        "
      >
        <h2>${errorMsg}</h2>
      </div>
    `;
  }

  throw new Error(errorMsg);
}

/**
 * Application environment configuration
 */
export const env = {
  /**
   * Application name
   */
  appTitle:
    import.meta.env.VITE_APP_NAME ||
    'ProcureAI Enterprise Platform',

  /**
   * Backend API URL
   */
  apiUrl:
    import.meta.env.VITE_API_BASE_URL ||
    'http://localhost:3000/api/v1',

  /**
   * SAP Simulator URL
   */
  sapSimulatorUrl:
    import.meta.env.VITE_SAP_SIMULATOR_URL ||
    'http://localhost:3001',

  /**
   * Enable / disable mock APIs
   */
  enableMocks,

  /**
   * Mock API response delay
   */
  mockDelayMs:
    Number(import.meta.env.VITE_MOCK_API_DELAY_MS) || 300,

  /**
   * Application environment
   */
  environment:
    import.meta.env.VITE_APP_ENV ||
    import.meta.env.MODE ||
    'development',

  /**
   * Production environment flag
   */
  isProduction,

  /**
   * Optional feature flags
   */
  enableSapSimulator:
    import.meta.env.VITE_ENABLE_SAP_SIMULATOR === 'true',

  enableAi:
    import.meta.env.VITE_ENABLE_AI === 'true',
};

export default env;